<template>
  <div class="like-btn">
    <button type="button" class="watchlist-btn" @click="toggleWatchlistState">
      <img :src="ico" alt="watchlist" />
      <p
        v-if="!showLoader"
        class="like-tag"
        :style="{
          color: ico !== like ? '#5568F1' : labelColor
        }"
      >
        {{ dislikeCount }}
      </p>
      <Loader v-else />
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/app";
import "firebase/database";
import Content from "@/mixins/Content";
import Utility from "@/mixins/Content";
import { EventBus } from "@/main";
export default {
  name: "DisLikeButton",
  props: ["content", "color", "container"],
  data() {
    return {
      action: null,
      ico: null,
      like: require("@/assets/icons/dislike_white.png"),
      liked: require("@/assets/icons/dislike_blue.png"),
      likeLabel: "Dislike",
      labelColor: "#F2F2F2",
      previousState: null,
      currentState: null,
      dislikeCount: 0,
      updated: true,
      showLoader: false
    };
  },
  computed: {
    ...mapGetters(["vendorid", "subscriberid"])
  },
  components: {
    Loader: () => import("@/components/Templates/loader.vue")
  },
  watch: {
    content() {
      this.fetchButtonState();
      this.listenToLikeDislikeCountChange();
    },
    subscriberid() {
      if (this.subscriberid) {
        this.fetchButtonState();
        this.listenToLikeDislikeCountChange();
      }
    }
  },
  mounted() {
    if (this.color === "BLACK") {
      this.like = require("@/assets/icons/dislike_black.svg");
      this.labelColor = "#000000";
    }
    this.ico = this.like;
    this.content.poster = this.getPoster(this.content, "PORTRAIT");

    this.fetchButtonState();
  },
  created() {
    this.listenToLikeDislikeCountChange();
    EventBus.$on(`${this.content.contentid}-likeDislikeStatus`, data => {
      this.updated = data;
    });
  },
  methods: {
    listenToLikeDislikeCountChange() {
      let path = `${this.vendorid}/content/${this.content.contentid}/dislike`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          let response = snapshot.val();
          EventBus.$emit(`${this.content.contentid}-likeDislikeStatus`, true);
          this.showLoader = false;
          if (response && typeof response.count == "number") {
            this.showLoader = false;
            this.dislikeCount = this.nFormatter(Math.abs(response.count), 1);
          } else {
            this.dislikeCount = 0;
          }
        });
    },
    fetchButtonState() {
      if (!this.content) return;
      this.showLoader = false;
      let content = this.content;
      let contentid = content.contentid;
      let path = `${this.vendorid}/subscriber/${this.subscriberid}/content/${contentid}`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          // this.updated = true;
          let response = snapshot.val();
          if (this.color === "BLACK") {
            this.like = require("@/assets/icons/dislike_black.svg");
            this.labelColor = "#000000";
          }
          if (response && response.likedislike === "DISLIKE") {
            this.action = "REMOVE";
            // this.ico = null;
            setTimeout(() => {
              this.ico = this.liked;
            }, 100);
            this.likeLabel = "Disliked";
            this.previousState = this.currentState = "DISLIKE";
          } else {
            if (response && response.likedislike === "LIKE") {
              this.previousState = this.currentState = "LIKE";
            } else {
              this.previousState = this.currentState = "NONE";
            }
            this.action = "ADD";
            this.ico = this.like;
            this.likeLabel = "Dislike";
          }
        });
    },
    toggleWatchlistState() {
      if (!this.updated) return;
      this.currentState =
        this.previousState === "LIKE"
          ? "DISLIKE"
          : this.previousState === "DISLIKE"
          ? "DISLIKE"
          : "NONE";

      if (this.subscriberid) {
        // console.log("DisLike clicked");
        this.updated = false;
        EventBus.$emit(`${this.content.contentid}-likeDislikeStatus`, false);
        this.showLoader = true;
        this.likeLabel = this.ico === this.like ? "Disliked" : "Dislike";
        this.ico = this.ico === this.like ? this.liked : this.like;

        // if (this.currentState === 'LIKE') {
        //   this.vLiveSDKContentLikeDislike(this.content, 1, this.previousState === 'DISLIKE' ? -1 : 0)
        // } else if (this.currentState === 'DISLIKE') {
        //   this.vLiveSDKContentLikeDislike(this.content, this.previousState === 'LIKE' ? -1 : 0, 1)
        // } else if (this.currentState === 'NONE') {
        //   this.vLiveSDKContentLikeDislike(this.content, this.previousState === 'LIKE' ? -1 : 0, this.previousState === 'DISLIKE' ? -1 : 0)
        // }

        if (this.action === "ADD") {
          this.updateLikeDislikeToFire(this.content, "DISLIKE");
        } else if (this.action === "REMOVE") {
          this.updateLikeDislikeToFire(this.content, "NONE");
        }
      } else {
        let data = {
          action: "DISLIKE",
          content: this.content
        };
        if (this.container == "Detail") {
          data.button = "LIKEDISLIKE";
        }
        if (this.container == "Share") {
          data.popup = "sharedPopup";
        }

        EventBus.$emit("LoginPopup", data);
      }
    }
  },
  mixins: [Content, Utility]
};
</script>

<style lang="scss">
.watchlist-btn {
  background: transparent;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/dislikeBtn.vue